import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import parentStyles from '../styles.module.scss'
import EmptyCard from 'srcReact/Dashboard/components/common/EmptyCard'
import { useTranslation } from 'react-i18next'
import CardSubTitle from 'srcReact/Dashboard/components/common/CardSubTitle'
import Counts from 'srcReact/Dashboard/components/common/Counts'
import GroupsActivityGraph from '../GroupsActivityGraph'
import Avatar from 'srcReact/components/common2/Avatar'
import { formatLastUpdateDate } from 'srcReact/helpers/datetimeHelper'
import { isMobileScreen } from 'srcReact/helpers/utils'

function GroupsActivity({ objectId, groupsActivityData, duration, loading }) {
  const { t } = useTranslation()
  const [groupsData, setGroupsData] = useState(null)
  const [graphData, setGraphData] = useState(null)
  useEffect(() => {
    if (groupsActivityData && groupsActivityData[duration]) {
      const durationData = groupsActivityData[duration]
      if (durationData) {
        setGroupsData(durationData)
      }
      if (duration === '4W') {
        setGraphData(groupsActivityData['7D'])
      } else if (duration === '88D') {
        setGraphData(groupsActivityData['22D'])
      } else {
        setGraphData(groupsActivityData['91D'])
      }
    }
  }, [groupsActivityData, duration])

  return (
    <div className={parentStyles.activityData}>
      <div className={parentStyles.left}>
        {groupsData?.new_group?.length > 0 ? (
          <div className={parentStyles.list}>
            {groupsData?.new_group.map((group, index) => {
              const groupInfo = group.group_info
              return (
                <div
                  key={groupInfo?.id}
                  className={styles.listItem}
                  onClick={() => {
                    window.location.href = groupInfo?.url
                  }}>
                  <div
                    style={
                      groupInfo.picture.url
                        ? {
                            backgroundImage: `url(${groupInfo.picture.url})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                            backgroundSize: 'cover'
                          }
                        : null
                    }
                    className={`${styles.picture} ${!groupInfo.picture.url && styles['defaultImage']}`}
                  />
                  <div className={styles.groupInfo}>
                    <p className={styles.groupName}>{groupInfo.name}</p>
                    <div className={styles.user}>
                      <Avatar
                        imgWrapperSize='tiny16'
                        userId={14316}
                        profilePicture={groupInfo.organizer?.picture_url}
                        firstname={groupInfo.organizer.firstname}
                        lastname={groupInfo.organizer.lastname}
                        mimeType={groupInfo.organizer.mime_type}
                        originalTag={groupInfo.organizer.original_tag}
                        isOriginal={groupInfo.organizer.is_original}
                      />
                      <p className={styles.name}>{groupInfo.organizer.display_name}</p>
                    </div>
                  </div>
                  <p className={styles.time}>{formatLastUpdateDate(groupInfo.created_at, '', t)}</p>
                </div>
              )
            })}
          </div>
        ) : (
          <EmptyCard
            className={styles.invites}
            contentTitle={t('dashboard.activity.newGroups.empty.title')}
            contentText={t('dashboard.activity.newGroups.empty.text')}
            contentImage='void'
            contentButton={t('nav.create_group')}
            contentButtonLink={`/0/create-group`}
            linkTarget='_blank'
          />
        )}
      </div>
      {!isMobileScreen() && (
        <div className={parentStyles.right}>
          <Counts
            countTitle={t('dashboard.activity.newGroups.newMembershipCount', {
              count: parseInt(groupsData?.new_membership?.value)
            })}
            totalCountTitle={t('dashboard.activity.newGroups.totalMembershipCount', {
              count: parseInt(groupsData?.total_membership?.value)
            })}
            count={groupsData?.new_membership_variation?.value}
            totalCount={groupsData?.total_membership_variation?.value}
          />
          <GroupsActivityGraph graphData={graphData?.groups_graph} />
        </div>
      )}
    </div>
  )
}

export default GroupsActivity
